var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkdownFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 4.16675C3.33301 2.78604 4.4523 1.66675 5.83301 1.66675H10.6308C11.2938 1.66675 11.9297 1.93014 12.3986 2.39898L15.9341 5.93451C16.4029 6.40336 16.6663 7.03924 16.6663 7.70228V15.8334C16.6663 17.2141 15.5471 18.3334 14.1663 18.3334H5.83301C4.4523 18.3334 3.33301 17.2141 3.33301 15.8334V4.16675ZM14.1663 17.3334H5.83301C5.00458 17.3334 4.33301 16.6618 4.33301 15.8334V4.16675C4.33301 3.33832 5.00458 2.66675 5.83301 2.66675H10.6308C10.6706 2.66675 10.7102 2.66833 10.7496 2.67146V5.83342C10.7496 6.79991 11.5331 7.58342 12.4996 7.58342H15.6616C15.6648 7.62282 15.6663 7.66247 15.6663 7.70228V15.8334C15.6663 16.6618 14.9948 17.3334 14.1663 17.3334ZM15.1688 6.58342L11.7496 3.16421V5.83342C11.7496 6.24763 12.0854 6.58342 12.4996 6.58342H15.1688Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5427 11.6667L9.09803 13.4787C9.24791 13.6533 9.22786 13.9164 9.05325 14.0662C8.87864 14.2161 8.61559 14.1961 8.4657 14.0215L6.83589 12.1228C6.61069 11.8604 6.61069 11.4731 6.83589 11.2107L8.4657 9.31203C8.61559 9.13742 8.87864 9.11737 9.05325 9.26726C9.22786 9.41714 9.24791 9.6802 9.09803 9.85481L7.5427 11.6667ZM10.6696 9.26726C10.495 9.41714 10.4749 9.6802 10.6248 9.85481L12.1802 11.6667L10.6248 13.4787C10.4749 13.6533 10.495 13.9164 10.6696 14.0662C10.8442 14.2161 11.1073 14.1961 11.2572 14.0215L12.887 12.1228C13.1122 11.8604 13.1122 11.4731 12.887 11.2107L11.2572 9.31203C11.1073 9.13742 10.8442 9.11737 10.6696 9.26726Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdownFile);
export default __webpack_public_path__ + "static/media/markdownFile.62de7779184ec1eaaa4fd316d702a4da.svg";
export { ForwardRef as ReactComponent };